import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

type ScreenWiperStatuses = 'start' | 'end' | '';

@Injectable()
export class ScreenWiperService {
  private screenWipeState = 0;
  private screenClasses = new BehaviorSubject<string>(`screen-wiper state-${this.screenWipeState}`);
  public screenClasses$ = this.screenClasses.asObservable();

  private globalWiperVisible = new BehaviorSubject<boolean>(false);
  public globalWiperVisible$ = this.globalWiperVisible.asObservable();

  public readonly wipeDuration = 5000;

  constructor(private snackbarService: SnackbarService) {}

  next(globalWiper = false) {
    this.globalWiperVisible.next(globalWiper);
    if (globalWiper) {
      setTimeout(() => this.runWiper(globalWiper), 100);
    } else {
      this.runWiper(globalWiper);
    }
  }

  private runWiper(globalWiper: boolean) {
    this.screenWipeState = (this.screenWipeState + 1) % 3;
    this.setClasses('start');
    setTimeout(() => {
      if (globalWiper) {
        this.snackbarService.info("Preventing monitor burn-in. You're welcome. 😰", this.wipeDuration);
      }
      this.setClasses('end');
      setTimeout(() => {
        this.setClasses('');
      }, this.wipeDuration);
    }, 10);
  }

  private setClasses(status: ScreenWiperStatuses) {
    this.screenClasses.next(`screen-wiper state-${this.screenWipeState} ${status}`);
  }
}
